import { z } from 'zod';
import { uuid } from './common.js';

export const email = z.string().email().max(254);
export const password = z.string().min(8).max(200);

export const registerRequest = z.object({
  email,
  password,
});
export type RegisterRequest = z.infer<typeof registerRequest>;

export const loginRequest = z.object({
  email,
  password,
});
export type LoginRequest = z.infer<typeof loginRequest>;

export const resetPasswordRequest = z.object({
  email,
});
export type ResetPasswordRequest = z.infer<typeof resetPasswordRequest>;

export const resetConfirmRequest = z.object({
  token: z.string().min(1),
  password,
});
export type ResetConfirmRequest = z.infer<typeof resetConfirmRequest>;

export const deleteAccountRequest = z.object({
  password: z.string().min(1),
});
export type DeleteAccountRequest = z.infer<typeof deleteAccountRequest>;

export const sessionUser = z.object({
  id: uuid,
  email,
  entitled: z.boolean(),
});
export type SessionUser = z.infer<typeof sessionUser>;

export const meResponse = z.object({
  email,
  createdAt: z.number().int(),
  entitlement: z.enum(['none', 'paid']),
  sessions: z.number().int().nonnegative(),
});
export type MeResponse = z.infer<typeof meResponse>;
